/**
 * TanStack Router: /revfinops/clients
 *
 * This route file was auto-generated by the route generation script.
 * Component: RevFinOpsClientsPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import RevFinOpsClientsPage from '@/app/revfinops/clients/page'

/**
 * Route: /revfinops/clients
 * Layout: _auth (authenticated)
 * Component: RevFinOpsClientsPage
 */
export const Route = createFileRoute('/_auth/revfinops/clients/')({
  component: RevFinOpsClientsPage,
})
